import { useState, useEffect } from "react";
import { WATCH_PLACEHOLDER_IMG } from "../data/placeholderImage";

/**
 * Product image with a guaranteed fallback.
 *
 * Two distinct failure modes have to be handled, and only one of them fires onError:
 *   1. `src` is a URL that fails to load  -> onError fires, we swap in the placeholder.
 *   2. the product has no image at all    -> `src` is undefined/"", React omits the
 *      attribute, the browser never makes a request, and onError NEVER fires. This
 *      case has to be detected up front or the user just sees an empty box.
 */
const WatchImg = ({ src, alt, className, style }) => {
  const [errored, setErrored] = useState(false);

  const hasSrc = typeof src === "string" && src.trim() !== "";
  const showPlaceholder = !hasSrc || errored;

  // The same <img> instance is reused as `src` changes (e.g. paging through the
  // detail gallery). Without this, one broken image would leave every subsequent
  // image stuck on the placeholder.
  useEffect(() => {
    setErrored(false);
  }, [src]);

  return (
    <img
      className={`${className || ""}${showPlaceholder ? " img-placeholder" : ""}`.trim()}
      style={style}
      src={showPlaceholder ? WATCH_PLACEHOLDER_IMG : src}
      alt={showPlaceholder ? `${alt || "Watch"} — image coming soon` : alt}
      loading="lazy"
      draggable={false}
      onError={() => setErrored(true)}
    />
  );
};

export default WatchImg;
